// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@salesforce/design-system-react';
import link from '../../utilities/link';

function HomepageCalendarItem(props) {
  return (
    <div className="slds-grid slds-p-bottom--xx-small" {...link(props.onClick)}>
      <span className="slds-truncate slds-text-color--weak">
        <Icon
          assistiveText={{ label: props.iconAssistiveText }}
          category={props.iconCategory}
          containerClassName="slds-m-right--x-small"
          icon={props.icon}
          name={props.iconName}
          size="small"
          style={props.iconStyle}
        />
        {props.text}
      </span>
    </div>
  );
}

HomepageCalendarItem.displayName = 'HomepageCalendarItem';

HomepageCalendarItem.propTypes = {
  /**
   * An SVG object to use instead of name / category, look in `design-system-react/icons` for examples
   */
  icon: PropTypes.object,
  /**
   * Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means.
   * Naked icons must have assistive text, however, if you also have visible descriptive text with the icon,
   * declare this prop as <code>assistiveText=''</code>.
   */
  iconAssistiveText: PropTypes.string,
  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
   */
  iconName: PropTypes.string,
  /**
   * Icon category from [lightningdesignsystem.com/icons/](https://www.lightningdesignsystem.com/icons/)
   */
  iconCategory: PropTypes.string,
  /**
   * Icon style from https://react.lightningdesignsystem.com/components/icons/#prop-containerStyle
   */
  iconStyle: PropTypes.object,
  /**
   * Calendar Item description text
   */
  text: PropTypes.string,
  /**
   * Callback fired when Calendar Item is clicked
   */
  onClick: PropTypes.func,
};

HomepageCalendarItem.defaultProps = {
  iconCategory: 'standard',
};

export default HomepageCalendarItem;
